/**
 * A function that sends Google Analytics events that
 *
 * @param {string} eventAction is the string that will appear as the event action n Google Analytics Event reports.
 * @param {Object} eventData is the event object to send to GA
 * @param {string} eventData.eventCategory is the string that will appear as the event category
 * @param {string|number} eventData.eventLabel is the string that will appear as the event label
 * @param {boolean} [debug=false] option to print out the event in the console.
 */
export default function trackEvent(eventAction, eventData, debug = false) {
  if (window.gtag) {
    window.gtag("event", eventAction, {
      event_category: (eventData && eventData.eventCategory) || "",
      event_label: (eventData && eventData.eventLabel) || "",
    });

    if (process.env.NODE_ENV === "development" && debug) {
      // tslint:disable: no-console
      console.group("google analytics");
      console.log("event");
      console.log(eventAction);
      console.log(eventData);
      console.groupEnd();
    }
  }
}
